import { render } from "./Concept.vue?vue&type=template&id=bddac94e&scoped=true"
import script from "./Concept.vue?vue&type=script&lang=js"
export * from "./Concept.vue?vue&type=script&lang=js"

import "./Concept.vue?vue&type=style&index=0&id=bddac94e&lang=scss&scoped=true"

import exportComponent from "D:\\Nerd\\RumbleFish\\Website\\Code\\rumblefish\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bddac94e"]])

export default __exports__